import React from "react" ;
import { Switch, Route, Link } from "react-router-dom";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';

import { Globals } from "root/DataFunctions/BaseDataFns";

import Learning from "../Pages/Learning";
import Feelings from "../Pages/Feelings";
import Games from "../Pages/Games";
import Help from "../Pages/ArchBoxHelp";

const Resources = (props) => {
    const pathArray = props.location.pathname.split("/");
    const currentPageName = pathArray[pathArray.length - 1];

    const resourcesIconUrl = Globals.BaseURL + "/images/icons/child/book-stack.png";
    const feelingsIconUrl = Globals.BaseURL + "/images/icons/child/reaction.png";
    const gamesIconUrl = Globals.BaseURL + "/images/icons/child/rubik.png";
    const helpIconUrl = Globals.BaseURL + "/images/icons/child/help.png";
    
    return (
        <div className="child-body-content">
            <div className="child-body-content-inner">
                <div className="post-nav">
                    <div className="navigation">
                        <ul>
                            <li 
                                className={currentPageName === "resources" ? "list active" : "list"}
                            >
                                <Link to="/child/resources">                      
                                    <OverlayTrigger
                                        placement="right"
                                        overlay={
                                            <Tooltip id="tooltip-right">
                                                Learning
                                            </Tooltip>
                                        }
                                        >
                                        <span className="icon">
                                            <img className="img" src={resourcesIconUrl} alt="Resources icon" />
                                        </span>
                                    </OverlayTrigger>
                                </Link>
                            </li>

                            <li 
                                className={currentPageName === "feelings" ? "list active" : "list"}
                            >
                                <Link to="/child/resources/feelings">
                                    <OverlayTrigger
                                        placement="right"
                                        overlay={
                                            <Tooltip id="tooltip-right">
                                                Feelings
                                            </Tooltip>
                                        }
                                        >
                                        <span className="icon">
                                            <img className="img" src={feelingsIconUrl} alt="Feelings icon" />
                                        </span>
                                    </OverlayTrigger>
                                </Link>
                            </li>

                            <li 
                                className={currentPageName === "games" ? "list active" : "list"}
                            >
                                <Link to="/child/resources/games">
                                    <OverlayTrigger
                                        placement="right"
                                        overlay={
                                            <Tooltip id="tooltip-right">
                                                Games
                                            </Tooltip>
                                        }
                                        >
                                        <span className="icon">
                                            <img className="img" src={gamesIconUrl} alt="Games icon" />
                                        </span>
                                    </OverlayTrigger>
                                </Link>
                            </li>

                            <li 
                                className={currentPageName === "help" ? "list active" : "list"}
                            >
                                <Link to="/child/resources/help">
                                    <OverlayTrigger
                                        placement="right"
                                        overlay={
                                            <Tooltip id="tooltip-right">
                                                Help
                                            </Tooltip>
                                        }
                                        >
                                        <span className="icon">
                                            <img className="img" src={helpIconUrl} alt="child help icon" />
                                        </span>
                                    </OverlayTrigger>
                                </Link>
                            </li>
                            
                        </ul>
                    </div>
                </div>

                <Switch>
                    <Route exact path="/child/resources" component={Learning} />
                    <Route exact path="/child/resources/feelings" component={Feelings} />
                    <Route exact path="/child/resources/games" component={Games} />
                    <Route exact path="/child/resources/help" component={Help} />
                </Switch>

            </div>
        </div>
    );
}

export default Resources;
